import {ASSET_URL, FALLBACK_IMAGE} from '~/assets/js/constants'

export const useItemImageUrlHelper = () => {
  const url = useRuntimeConfig().public.ASSET_URL || ASSET_URL
  const pimBaseUrl = useRuntimeConfig().public.pimDataBaseUrl || ''

  const getImageFromItem = (item: any, isProduct: boolean, categories: any = null) => {
    let asset = null
    if (typeof item === 'object' && item !== null) {
      // item is Product and has property designSketch
      if (isProduct && item.designSketch && item.designSketch !== '') {
        asset = item.designSketch
        return asset
      }
      // item is Category and has property DesignSketch
      else if (item && item.DesignSketch) {
        asset = item.DesignSketch
        return asset
      }
      // item is Category and has property DesignSketchAssetURI
      else if (!isProduct && item.DesignSketchAssetURI && item.DesignSketchAssetURI !== '') {
        asset = item.DesignSketchAssetURI
        return asset
      }
    }
    // item is type string so we are looking for design in category
    else if (typeof item === 'string' && Array.isArray(categories)) {
      const category = categories.find((c: any) => c.TechnicalName === item)
      if (category) {
        asset = category.DesignSketch || category.DesignSketchAssetURI
      } else {
        //pim case
        const category = categories.find((c: any) => c.technicalName === item)
        if (category) {
          if (category.designSketchImage?.sizes && category.designSketchImage.sizes['easy-small']?.imgUrl && !category.designSketchImage.imgURL.endsWith('.svg')) {
            asset = pimBaseUrl + '/' + category.designSketchImage.sizes['easy-small'].imgUrl
          } else {
            asset = pimBaseUrl + '/' + category.designSketchImage?.imgURL
          }
        }
      }
    }
    //for new experimental search
    if (asset === null && typeof item === 'object' && Array.isArray(categories)) {
      const category = categories.find((c: any) => c.TechnicalName === item.primaryL2Category)
      if (category) {
        asset = category.DesignSketch || category.DesignSketchAssetURI
      }
    }
    return asset
  }

  const installationImageUrl = (item: any, isProduct: boolean = false) => {
    let asset = null
    if (isProduct) {
      if (item && item.designInstallationSketch && item.designInstallationSketch !== '') {
        asset = item.designInstallationSketch
      }
    }
    else {
      if (item && item.InstallationSketch) {
        asset = item.InstallationSketch
      }
      else if (item && item.InstallationSketchAssetURI && item.InstallationSketchAssetURI !== '') {
        asset = item.InstallationSketchAssetURI
      }
    }

    if (asset === FALLBACK_IMAGE || !asset) {
      return FALLBACK_IMAGE
    }

    return typeof asset === 'string' ? addAssetUrlPartIfNeeded(asset) : asset.url
  }

  const addAssetUrlPartIfNeeded = (asset: any) => {
    if (asset.startsWith('http') || asset.startsWith(pimBaseUrl)) {
      return asset
    }
    // Handle cases where asset starts with / and/or url ends with /
    const baseUrl = url.endsWith('/') ? url.slice(0, -1) : url
    const path = asset.startsWith('/') ? asset : '/' + asset
    return baseUrl + path
  }

  const imageUrl = (item: any, isProduct: boolean = false, categories: any = null) => {
    const asset = getImageFromItem(item, isProduct, categories)

    if (asset === FALLBACK_IMAGE || !asset) {
      return FALLBACK_IMAGE
    }

    return typeof asset === 'string' ? addAssetUrlPartIfNeeded(asset) : asset.url
  }

  return {
    imageUrl,
    installationImageUrl,
    addAssetUrlPartIfNeeded,
    getImageFromItem
  }
}
